<template>
    <div class="g">
        <mdSearch>
            <cpDatePicker
                type="date"
                :errorStatus="errors.has('startDate')"
                :errorMsg="errors.first('startDate')"
                v-model="startDate"
                v-validate="'required'"
                :label="$t('site.noun.startdate')"
                name="startDate"
                ref="startDate"
            ></cpDatePicker>
            <cpDatePicker
                type="date"
                :errorStatus="errors.has('endDate')"
                :errorMsg="errors.first('endDate')"
                v-model="endDate"
                v-validate="'required|isAfter:'+ startDate"
                :label="$t('site.noun.enddate')"
                name="endDate"
                ref="endDate"
            ></cpDatePicker>
            <cpBtn
                icon="get_app"
                :text="$t('site.noun.load')"
                @click.prevent="init"
            ></cpBtn>
            <cpBtn
                icon="cloud_download"
                :title="$t('page.mypurchase.func.download')"
                themes= 'warning'
                @click.prevent="download"
            ></cpBtn>
        </mdSearch>
        <mdSearch>
            <cpCombobox
                :label="$t('site.noun.product')"
                :nullString="$t('site.noun.all')"
                :options="dsrList"
                v-model="dsr"
            ></cpCombobox>
        </mdSearch>
        <gRow>
            <gCell>
                <gRow>
                    <gCell>
                        <mdCaption
                            :caption="$t('page.mypurchase.caption.purchasetot')"
                        ></mdCaption>
                        <div class="g card-area">
                            <div class="info">
                                {{ $t('page.mypurchases.item.yoy') }}
                                <cpLabel
                                    :themes="totalPrice === prevTotalPrice? 'minor': totalPrice > prevTotalPrice? 'danger': 'success'"
                                    :icon="totalPrice === prevTotalPrice? 'remove': totalPrice > prevTotalPrice? 'arrow_drop_up': 'arrow_drop_down'"
                                    :text="$okaTool.numberToStringFormat(((totalPrice - prevTotalPrice) / prevTotalPrice) * 100, 2) +'%'"
                                ></cpLabel>
                            </div>
                            <div class="price">
                                NT$ {{ $okaTool.numberToStringFormat(totalPrice) }}
                            </div>
                        </div>
                    </gCell>
                    <gCell>
                        <mdCaption
                            :caption="$t('page.mypurchase.caption.purchaseqty')"
                        ></mdCaption>
                        <div class="g card-area">
                            <div class="info">
                                {{ $t('page.mypurchases.item.yoy') }}
                                <cpLabel
                                    :themes="totalWeight === prevTotalWeight? 'minor': totalWeight > prevTotalWeight? 'danger': 'success'"
                                    :icon="totalWeight === prevTotalWeight? 'remove': totalWeight > prevTotalWeight? 'arrow_drop_up': 'arrow_drop_down'"
                                    :text="$okaTool.numberToStringFormat(((totalWeight - prevTotalWeight) / prevTotalWeight) * 100, 2) +'%'"
                                ></cpLabel>
                            </div>
                            <div class="weight">
                                {{ $okaTool.numberToStringFormat(totalWeight, 2) }} KG
                            </div>
                        </div>
                    </gCell>
                </gRow>
                <gRow>
                    <gCell>
                        <div class="card-area">
                            <mdCaption
                                :caption="$t('page.mypurchase.caption.product')"
                            ></mdCaption>
                            <div class="g card-area">
                                <mdChart
                                    :obj="productConsumption"
                                    :height="300"
                                ></mdChart>
                            </div>
                        </div>
                    </gCell>
                </gRow>
            </gCell>
            <gCell>
                <gRow>
                    <gCell>
                        <mdCaption
                            :caption="$t('page.mypurchase.caption.price')"
                        ></mdCaption>
                        <div class="g card-area">
                            <mdChart
                                :obj="productPrice"
                                :height="465"
                            ></mdChart>
                        </div>
                    </gCell>
                </gRow>
            </gCell>
        </gRow>
        <gRow>
            <gCell>
                <gRow>
                    <gCell>
                        <mdCaption
                            :caption="$t('page.mypurchase.caption.pattern')"
                        ></mdCaption>
                        <div class="g card-area">
                            <mdChart
                                :obj="buyingTrend"
                                :height="500"
                            ></mdChart>
                        </div>
                    </gCell>
                </gRow>
            </gCell>
        </gRow>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import gRow from '@/components/gRow'
    import gCell from '@/components/gCell'
    import gCard from '@/components/gCard'
    import mdSearch from '@/components/mdSearch'
    import mdChart from '@/components/mdChart'
    import cpDatePicker from '@/components/cpDatePicker'
    import cpCombobox from '@/components/cpCombobox'
    import cpLabel from '@/components/cpLabel'
    import cpBtn from '@/components/cpBtn'

    import VueCookie from 'vue-cookie'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            gRow,
            gCell,
            gCard,
            mdSearch,
            mdChart,
            cpDatePicker,
            cpCombobox,
            cpLabel,
            cpBtn,
        },
        data: function(){
            let $time = new Date(),
                _year = $time.getFullYear(),
                _month = $time.getMonth() + 1,
                _startDate = _year +'-'+ this.$okaTool.doubleCount(_month) +'-01',
                $lastDate = new Date(_year, _month, 0),
                _date = $lastDate.getDate(),
                _endDate = _year +'-'+ this.$okaTool.doubleCount(_month) +'-'+ this.$okaTool.doubleCount(_date);

            let _dataSearchStart = VueCookie.get('dataSearchStart'),
                _dataSearchEnd = VueCookie.get('dataSearchEnd');

            if( _dataSearchStart ) {
                _startDate = _dataSearchStart;
            }

            if( _dataSearchEnd ) {
                _endDate = _dataSearchEnd;
            }

            return {
                startDate: _startDate,
                UIstartDate: _startDate,
                endDate: _endDate,
                UIendDate: _endDate,
                dsr: '',
                list: [],
                prevList: [],
                colorSet: [], //圖表品別對應顏色
                productConsumption: {},
                productPrice: {},
                buyingTrend: {},
            }
        },
        computed: {
            ...mapState([
                'packageData',
                'qualityList',
                'productList',
            ]),
            dsrList: function(){
                let $list = this.list,
                    $prevList = this.prevList,
                    $all = $list.concat($prevList),
                    $result = []
                
                $all.forEach(item => {
                    let _dsr = item.product_s,
                        _alias = item.alias;
                    
                    if( _alias ){
                        if( !$result.includes(_alias) ) {
                            $result.push(_alias);
                        }
                    }else{
                        if( !$result.includes(_dsr) ) {
                            $result.push(_dsr);
                        }
                    }
                });

                return $result;
            },
            useList: function(){
                return this.getList(this.list, this.dsr);
            },
            usePrevList: function(){
                return this.getList(this.prevList, this.dsr);
            },
            totalPrice: function(){
                return this.getPurchaseTotal(this.useList, 'totalprice');
            },
            prevTotalPrice: function(){
                return this.getPurchaseTotal(this.usePrevList, 'totalprice');
            },
            totalWeight: function(){
                return this.getPurchaseTotal(this.useList, 'qty');
            },
            prevTotalWeight: function(){
                return this.getPurchaseTotal(this.usePrevList, 'qty');
            },
            intervalDate: function(){
                let _startDate = this.UIstartDate,
                    $startDate = new Date(_startDate),
                    _startTime = $startDate.getTime(),
                    _endDate = this.UIendDate,
                    $endDate = new Date(_endDate),
                    _endTime = $endDate.getTime();

                let _aDay = 24 * 60 * 60 * 1000,
                    _current = _startTime,
                    $result = [_startTime]

                while ( _current < _endTime ) {
                    _current = _current + _aDay;

                    $result.push(_current);
                }

                $result = $result.map(item => {
                    let $time = this.$okaTool.timeInterval({
                            time: new Date(item),
                            unit: 'date'
                        }),
                        _time = $time.ymd;

                    return _time;
                });

                return $result;
            },
        },
        watch: {
            useList: {
                handler: function(){
                    this.getProductConsumption();
                    this.getProductPrice();
                    this.getBuyingTrend();
                }
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushPopUp',
                'pushNotification',
            ]),
            download:  function(){
                let $user = this.user
             
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'Download',
                    }),
                    $condition = {
                        startdate: this.startDate,
                        enddate: this.endDate,
                    }

                try{
                    this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                        this.$siteTool.download(res)

                        this.pushNotification({
                            type: 'notification',
                            content: {
                                html: this.$t('site.status.downloadSuccess'),
                                status: 'success'
                            }
                        });
                    });
                } 
                catch(error) {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.download()
                        },
                    });
                }
            },
            getColor: function(dsr){
                let $colorSet = this.colorSet, //array
                    $target = $colorSet.find(item => item.key === dsr);

                if( !$target ) {
                    let _length = $colorSet.length,
                        $colorList = this.$okaTool.colorList,
                        $colorsLength = $colorList.length;

                    $target = {
                        key: dsr,
                        color: $colorList[_length % $colorsLength],
                    }

                    this.colorSet.push($target)
                }

                return $target.color;
            },
            getProductConsumption: function() {
                let $colors = [],
                    $labels = [],
                    $datas = []

                let $data = {
                        labels: $labels,
                        datasets: [
                            {
                                backgroundColor: $colors,
                                data: $datas
                            }
                        ]
                    },
                    $options = {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    display: false
                                }
                            ],
                            yAxes: [
                                {
                                    display: false
                                }
                            ]
                        },
                        tooltips: {
                            mode: 'label',
                            callbacks: {
                                label: (tooltipItem, data) => {
                                    let _indice = tooltipItem.index;

                                    return data.labels[_indice] +': '+ this.$okaTool.numberToStringFormat(data.datasets[0].data[_indice]);
                                }
                            }
                        },
                        plugins: {
                            labels: {
                                fontColor: '#000'
                            }
                        }
                    };

                let $list = this.useList;
               
                $list.forEach(item => {
                    let _dsr = item.product_s,
                        _alias = item.alias,
                        _qty = item.qty;

                    let _index  = $labels.indexOf(_dsr);

                    if( _index >= 0 ) {
                        $datas[_index] += _qty;
                    }else {
                        let _color = 'rgba('+ this.$okaTool.hexToRgb(this.getColor(_dsr)).join(',') +', .6)';

                        $labels.push(_dsr);
                        $colors.push(_color);
                        $datas.push(_qty);
                    }
                });
                
                for(let i = 0; i < $labels.length; i++){
                    let _name = this.useList.find(goods => goods.product_s === $labels[i]);
                    let _abbr = _name.alias;
                    if( _abbr ){
                        $labels[i] = _abbr
                    }
                }

                this.$set(this, 'productConsumption', {
                    type: 'pie',
                    data: $data,
                    options: $options
                });
            },
            getProductPrice: function() {
                let $datasets = []
                
                let $data = {
                        datasets: $datasets,
                    },
                    $options = {
                        legend: {
                            display: false
                        },
                        tooltips: {
                            displayColors: false,
                            callbacks: {
                                label: (t, d) => {
                                    let $node = d.datasets[t.datasetIndex].node,
                                        $object = {
                                            aodat: {
                                                name: this.$t('page.mypurchases.item.date'),
                                                data: $node.aodat.replace('T00:00:00', '').replaceAll('-', '/'),
                                            },
                                            alias: {
                                                name: this.$t('page.mypurchases.item.alias'),
                                                data: $node.alias,
                                            },
                                            product_s: {
                                                name: this.$t('page.mypurchases.item.product'),
                                                data: $node.product_s,
                                            },
                                            package: {
                                                name: this.$t('page.mypurchases.item.packaging'),
                                                data: this.getPackage($node.product_s, $node.package),
                                            },
                                            quality: {
                                                name: this.$t('page.mypurchases.item.quality'),
                                                data: this.getQuality($node.product_s, $node.quality),
                                            },
                                            price: {
                                                name: this.$t('page.mypurchases.item.unitprice'),
                                                data: this.$okaTool.numberToStringFormat($node.totalprice / $node.qty),
                                            },
                                            qty: {
                                                name: this.$t('page.mypurchases.item.qty'),
                                                data: this.$okaTool.numberToStringFormat($node.qty),
                                            },
                                            totalprice: {
                                                name: this.$t('page.mypurchases.item.subtotal'),
                                                data: this.$okaTool.numberToStringFormat($node.totalprice),
                                            },
                                        }

                                    let $result = []

                                    for( let _key in $object ) {
                                        let $target = $object[_key]

                                        if( $target.data ) {
                                            $result.push($target.name +': '+ $target.data);
                                        }
                                        
                                    }

                                    return $result;
                                }
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        lineTension: 1,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true,
                                        labelString:this.$t('page.mypurchase.diagram.kgqty')
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 10,
                                        callback: (num) => {
                                            return this.$okaTool.numberToStringFormat(num);
                                        }
                                    },
                                }
                            ],
                            xAxes: [
                                {
                                    scaleLabel: {
                                        display: true,
                                        labelString:this.$t('page.mypurchase.diagram.price')
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 10,
                                        callback: (num) => {
                                            return this.$okaTool.numberToStringFormat(num);
                                        }
                                    },
                                }
                            ]
                        }
                    }

                let $list = this.useList;

                $list.forEach(item => {

                    $datasets.push({
                        label: item.product_s,
                        node: item,
                        data: [
                            {
                                x: item.up,
                                y: item.qty,
                                r: 8,
                            }
                        ],
                        backgroundColor: 'rgba('+ this.$okaTool.hexToRgb(this.getColor(item.product_s)).join(',') +', .5)', //顏色轉 rgba 並給透明度
                        borderWidth: 1,
                        borderColor: 'rgba(51, 51, 51, 1)'
                    });
                });

                this.$set(this, 'productPrice', {
                    type: 'bubble',
                    data: $data,
                    options: $options
                });
            },
            getBuyingTrend: function() {
                let $labels = this.intervalDate,
                    $datasets = []

                let _labelLength = $labels.length,
                    $sample = []

                for( let _i = 0; _i < _labelLength; _i++ ) {
                    $sample.push(0);
                }
                
                let $data = {
                        labels: $labels,
                        datasets: $datasets,
                    },
                    $options = {
                        responsive: true,
                        maintainAspectRatio: false,
                        lineTension: 1,
                        scales: {
                            yAxes: [
                                {
                                    stacked: true,
                                    scaleLabel: {
                                        display: true,
                                        labelString:this.$t('page.mypurchase.diagram.tonqty')
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 10,
                                        callback: (num) => {
                                            return this.$okaTool.numberToStringFormat(num);
                                        }
                                    },
                                },
                            ],
                            xAxes: [
                                {
                                    scaleLabel: {
                                        display: true,
                                        labelString:this.$t('page.mypurchase.diagram.date')
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        padding: 10,
                                        callback: (num) => {
                                            return num.replace(/\-/g, '/');
                                        }
                                    }
                                }
                            ]
                        },
                    }

                let $list = this.useList;

                $list.forEach(item => {
                    let _dsr = item.product_s,
                        _alias = item.alias,
                        _qty = item.qty,
                        _dtdat = item.aodat,
                        $time = this.$okaTool.timeInterval({
                            time: new Date(_dtdat),
                            unit: 'date'
                        }),
                        _time = $time.ymd,
                        _index = $labels.indexOf(_time);

                    if( _alias ){
                        let $target = $datasets.find(item => {
                            return item.label === _alias;
                        });

                        if( !$target ) {
                            let _color = 'rgba('+ this.$okaTool.hexToRgb(this.getColor(_dsr)).join(',') +', .6)';

                            $target = {
                                label: _alias,
                                data: this.$okaTool.copy($sample),
                                backgroundColor: _color,
                                stack: 1,
                            }

                            $datasets.push($target)
                        }

                        if( $target.data[_index] ) {
                            $target.data[_index] = $target.data[_index] + _qty;
                        }else {
                            $target.data[_index] = _qty;
                        }

                    }else{
                        let $target = $datasets.find(item => {
                            return item.label === _dsr;
                        });

                        if( !$target ) {
                            let _color = 'rgba('+ this.$okaTool.hexToRgb(this.getColor(_dsr)).join(',') +', .6)';

                            $target = {
                                label: _dsr,
                                data: this.$okaTool.copy($sample),
                                backgroundColor: _color,
                                stack: 1,
                            }

                            $datasets.push($target)
                        }

                        if( $target.data[_index] ) {
                            $target.data[_index] = $target.data[_index] + _qty;
                        }else {
                            $target.data[_index] = _qty;
                        }
                    }
                    // let $target = $datasets.find(item => {
                    //         return item.label === _dsr;
                    //     });

                    // if( !$target ) {
                    //     let _color = 'rgba('+ this.$okaTool.hexToRgb(this.getColor(_dsr)).join(',') +', .6)';

                    //     $target = {
                    //         label: _dsr,
                    //         data: this.$okaTool.copy($sample),
                    //         backgroundColor: _color,
                    //         stack: 1,
                    //     }

                    //     $datasets.push($target)
                    // }

                    // if( $target.data[_index] ) {
                    //     $target.data[_index] = $target.data[_index] + _qty;
                    // }else {
                    //     $target.data[_index] = _qty;
                    // }
                });

                this.$set(this, 'buyingTrend', {
                    type: 'bar',
                    data: $data,
                    options: $options
                });
            },
            getPackage: function(product_s, package_s){
                let $packageData = this.packageData,
                    _result = this.$t('site.func.sortdefault');

                if( package_s ) {
                    let $target = $packageData.find(item => {
                            return item.product_s === product_s && item.package_s === package_s;
                        });

                    if( $target ) {
                        _result = $target.remarks;
                    }else {
                        _result = package_s;
                    }
                }

                return _result;
            },
            getQuality: function(product_s, quality){
                let $qualityList = this.qualityList,
                    _result = this.$t('site.func.sortdefault');

                if( quality ) {
                    let $target = $qualityList.find(item => {
                            return item.product_s === product_s && item.quality === quality;
                        });

                    if( $target ) {
                        _result = $target.remarks;
                    }else {
                        _result = quality;
                    }
                }

                return _result;
            },
            getList: function(list, dsr){
                let $dsr = dsr.split(',');

                if( dsr && $dsr.length ) {
                    return list.filter(item => $dsr.includes(item.product_s));
                }else {
                    return list;
                }
            },
            getPurchaseTotal: function(list, prop){

                return list.reduce((all, item) => {
                    return all + item[prop]
                }, 0);
            },
            initData: function(data, target){ //init 取回來的資料
                this.$set(this, target, data);
                
                this.getProductConsumption();
                this.getBuyingTrend();
                this.getProductPrice();
            },
            getData: function(opt){ //init 畫面的時候要先取得資料
                let _url = this.$siteTool.apiUrl({
                        class: 'CustomerAnalysis',
                        func: 'List',
                    });

                return this.$http.post(_url, opt);
            },
            init: async function(){
                let _startDate = this.startDate,
                    _endDate = this.endDate,
                    $prevStartDate = this.$okaTool.timeInterval({
                        unit: 'y',
                        away: '<',
                        time: _startDate,
                        int: 1
                    }),
                    _prevStartDate = $prevStartDate.ymd,
                    $prevEndDate = this.$okaTool.timeInterval({
                        unit: 'y',
                        away: '<',
                        time: _endDate,
                        int: 1
                    }),
                    _prevEndDate = $prevEndDate.ymd;

                try {
                    let $response = await Promise.all([
                            this.getData({
                                startdate: _startDate,
                                enddate: _endDate,
                            }),
                            this.getData({
                                startdate: _prevStartDate,
                                enddate: _prevEndDate,
                            }),
                        ]);
                    
                    VueCookie.set('dataSearchStart', this.startDate, 0.5);
                    VueCookie.set('dataSearchEnd', this.endDate, 0.5);

                    this.$set(this, 'dsr', '');
                    this.$set(this, 'UIstartDate', _startDate);
                    this.$set(this, 'UIendDate', _endDate);

                    let [time, prevTime] = $response;

                    this.initData(time, 'list');
                    this.initData(prevTime, 'prevList');
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            },
        },
        created: function(){
            this.init();
        }
    }
</script>

<style scoped lang="scss">

    .info {

    }
    
    .price, .weight {
        line-height: 50px;
        font-size: $font-size-xxl;
        padding-left: $interval-l;
        font-weight: bold;

        @include media('center') {
            padding-left: 0;
            font-size: $font-size-xl;
        }

        @include media('phone') {
            font-size: $font-size-xxxl;
        }
    }

    .price {
        $type: map-get($colors, 'danger');
        $text: map-get($type, 'text');

        color: $text; 
    }

    .g.card-area {
        padding: $interval-m;
        border-radius: $border-radius;
        border: $border;
        // border-color: $light-gray;
        background-color: $white;
        // box-shadow: $box-shadow;
    }

    .weight {

    }

</style>
